import Header from '@/components/header'
import Footer from '@/components/footer'
import ClassName from 'clsx'
import Styles from './style.module.scss'

export default function PageWrapper({ contentClassName, soul, children, dark, mainStyle }: any) {
  return (
    <div className={Styles.page_wrapper}>
      <Header soul={soul} />
      <div className={ClassName(Styles.page_main, dark && Styles.dark, contentClassName)} style={mainStyle}>
        {children}
      </div>
      <Footer />
    </div>
  )
}
